<template>
  <span>
    <div v-if="sontPresents" class="row mt-3">
      <div class="col">
        <h6 class="font-weight-bold">Sont présents :</h6>
        <div>
          {{ presentTotal }} copropriétaires sur {{ total }}, représentant ensemble
          {{ formatNumber(presentTantiemesTotal) }} tantièmes
        </div>
        <div>{{ sontPresents }}</div>
      </div>
    </div>

    <div v-if="sontPresentsDistance" class="row mt-3">
      <div class="col">
        <h6 class="font-weight-bold">Sont présents à distance :</h6>
        <div>
          {{ presentDistanceTotal }} copropriétaires sur {{ total }}, représentant ensemble
          {{ formatNumber(presentDistanceTantiemesTotal) }} tantièmes
        </div>
        <div>{{ sontPresentsDistance }}</div>
      </div>
    </div>

    <div v-if="sontRepresentes" class="row mt-3">
      <div class="col">
        <h6 class="font-weight-bold">Sont représentés :</h6>
        <div>
          {{ representesTotal }} copropriétaires sur {{ total }}, représentant ensemble
          {{ formatNumber(representesTantiemesTotal) }} tantièmes
        </div>
        <div>{{ sontRepresentes }}</div>
      </div>
    </div>

    <div v-if="sontCorrespondences" class="row mt-3">
      <div class="col">
        <h6 class="font-weight-bold">Personnes qui ont voté par correspondance :</h6>
        <div>
          {{ correspondenceTotal }} copropriétaires sur {{ total }}, représentant ensemble
          {{ formatNumber(correspondenceTantiemesTotal) }} tantièmes
        </div>
        <div>{{ sontCorrespondences }}</div>
      </div>
    </div>

    <div v-if="sontInvalidCorrespondences" class="row mt-3">
      <div class="col">
        <h6 class="font-weight-bold">Personnes avec formulaire de correspondance invalide :</h6>
        <div>
          {{ invalidCorrespondenceTotal }} copropriétaires sur {{ total }}, représentant ensemble
          {{ formatNumber(invalidCorrespondenceTantiemesTotal) }} tantièmes
        </div>
        <div>{{ sontInvalidCorrespondences }}</div>
      </div>
    </div>

    <div v-if="sontAbsents" class="row mt-3">
      <div class="col">
        <h6 class="font-weight-bold">Sont absents et non représentés :</h6>
        <div>
          {{ absentsTotal }} copropriétaires sur {{ total }}, représentant ensemble
          {{ formatNumber(absentsTantiemesTotal) }} tantièmes
        </div>
        <div>{{ sontAbsents }}</div>
      </div>
    </div>
  </span>
</template>

<script>
import documentsMixin from "@/mixins/documents";

export default {
  mixins: [documentsMixin],
  inject: ["meeting"],
  props: {
    firstResolutionVote: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
  },
  data() {
    return {
      sontPresents: "",
      presentTotal: 0,
      presentTantiemesTotal: 0,
      sontPresentsDistance: "",
      presentDistanceTotal: 0,
      presentDistanceTantiemesTotal: 0,
      sontRepresentes: "",
      representesTotal: 0,
      representesTantiemesTotal: 0,
      sontCorrespondences: "",
      correspondenceTotal: 0,
      correspondenceTantiemesTotal: 0,
      sontInvalidCorrespondences: "",
      invalidCorrespondenceTotal: 0,
      invalidCorrespondenceTantiemesTotal: 0,
      sontAbsents: "",
      absentsTotal: 0,
      absentsTantiemesTotal: 0,
      total: 0,
    };
  },
  created() {
    const meetingStartInfo = this.getMeetingStartInfo(this.meeting, this.firstResolutionVote);
    this.getLists(meetingStartInfo);
  },
  methods: {
    getLists(meetingStartInfo) {
      const Present = meetingStartInfo.Present;
      const presentTantiemes = meetingStartInfo.tantiemesDetails.present;

      const PresentDistance = meetingStartInfo.PresentDistance;
      const presentDistanceTantiemes = meetingStartInfo.tantiemesDetails.present_distance;

      const Represented = meetingStartInfo.Represented;
      const representedTantiemes = meetingStartInfo.tantiemesDetails.represented;

      const Correspondence = meetingStartInfo.Correspondence;
      const correspondenceTantiemes = meetingStartInfo.tantiemesDetails.correspondence;

      const InvalidCorrespondence = meetingStartInfo.InvalidCorrespondence;
      const invalidCorrespondenceTantiemes =
        meetingStartInfo.tantiemesDetails.invalid_correspondence;

      const Absents = meetingStartInfo.Absents;
      const absentsTantiemes = meetingStartInfo.tantiemesDetails.absents;

      if (Present && presentTantiemes) {
        const { presenceTypeTotal, presenceTypeTotalTantiemes, presenceTypeString } = this.getList(
          Present,
          presentTantiemes
        );

        this.presentTotal = presenceTypeTotal;
        this.presentTantiemesTotal = presenceTypeTotalTantiemes;
        this.sontPresents = presenceTypeString;
      }

      if (PresentDistance && presentDistanceTantiemes) {
        const { presenceTypeTotal, presenceTypeTotalTantiemes, presenceTypeString } = this.getList(
          PresentDistance,
          presentDistanceTantiemes
        );

        this.presentDistanceTotal = presenceTypeTotal;
        this.presentDistanceTantiemesTotal = presenceTypeTotalTantiemes;
        this.sontPresentsDistance = presenceTypeString;
      }

      // different ..
      if (Represented && representedTantiemes) {
        const {
          presenceTypeTotal,
          presenceTypeTotalTantiemes,
          presenceTypeString,
        } = this.getListRepresented(Represented, representedTantiemes);

        this.representesTotal = presenceTypeTotal;
        this.representesTantiemesTotal = presenceTypeTotalTantiemes;
        this.sontRepresentes = presenceTypeString;
      }

      if (Correspondence && correspondenceTantiemes) {
        const { presenceTypeTotal, presenceTypeTotalTantiemes, presenceTypeString } = this.getList(
          Correspondence,
          correspondenceTantiemes
        );

        this.correspondenceTotal = presenceTypeTotal;
        this.correspondenceTantiemesTotal = presenceTypeTotalTantiemes;
        this.sontCorrespondences = presenceTypeString;
      }

      if (InvalidCorrespondence && invalidCorrespondenceTantiemes) {
        const { presenceTypeTotal, presenceTypeTotalTantiemes, presenceTypeString } = this.getList(
          InvalidCorrespondence,
          invalidCorrespondenceTantiemes
        );

        this.invalidCorrespondenceTotal = presenceTypeTotal;
        this.invalidCorrespondenceTantiemesTotal = presenceTypeTotalTantiemes;
        this.sontInvalidCorrespondences = presenceTypeString;
      }

      if (Absents && absentsTantiemes) {
        const { presenceTypeTotal, presenceTypeTotalTantiemes, presenceTypeString } = this.getList(
          Absents,
          absentsTantiemes
        );

        this.absentsTotal = presenceTypeTotal;
        this.absentsTantiemesTotal = presenceTypeTotalTantiemes;
        this.sontAbsents = presenceTypeString;
      }

      this.total =
        this.presentTotal +
        this.presentDistanceTotal +
        this.representesTotal +
        this.correspondenceTotal +
        this.invalidCorrespondenceTotal +
        this.absentsTotal;
    },
    getList(presenceTypeArray, presenceTypeTantiemes) {
      let presenceTypeTotal = presenceTypeArray.length;
      let presenceTypeTotalTantiemes = presenceTypeTantiemes;
      let presenceTypeString = "";

      let arrayToSort = [];
      for (const item of presenceTypeArray) {
        const buildingOwner = this.findBuildingOwnerData(item.building_owner_id);
        const itemUsedTantiemes = this.getUsedMandateTantiemesChargeGenerale(item.id);

        if (buildingOwner) {
          arrayToSort.push(
            `${this.getPersonName({ personId: buildingOwner.id })} (${itemUsedTantiemes})`
          );
        } else {
          presenceTypeTotal--;
          presenceTypeTotalTantiemes -= itemUsedTantiemes;
        }
      }
      presenceTypeString = arrayToSort.sort().join(", ");

      return {
        presenceTypeTotal,
        presenceTypeTotalTantiemes,
        presenceTypeString,
      };
    },
    getListRepresented(presenceTypeArray, presenceTypeTantiemes) {
      let presenceTypeTotal = presenceTypeArray.length;
      let presenceTypeTotalTantiemes = presenceTypeTantiemes;
      let presenceTypeString = "";

      let arrayToSort = [];
      for (const item of presenceTypeArray) {
        const buildingOwner = this.findBuildingOwnerData(item.building_owner_id);
        const itemUsedTantiemes = this.getUsedMandateTantiemesChargeGenerale(item.id);

        if (buildingOwner) {
          if (item.representant_owner_id) {
            const representantOwner = this.findBuildingOwnerData(item.representant_owner_id);

            arrayToSort.push(
              `${this.getPersonName({
                personId: buildingOwner.id,
              })} (${itemUsedTantiemes}) représenté(e.s) par ${this.getPersonName({
                personId: representantOwner.id,
              })}`
            );
          } else {
            const representantContact = this.findContactData(item.representant_contact_id);

            arrayToSort.push(
              `${this.getPersonName({
                personId: buildingOwner.id,
              })} (${itemUsedTantiemes}) représenté(e.s) par ${this.getPersonName({
                personId: representantContact.id,
                personType: "contact",
              })}`
            );
          }
        } else {
          presenceTypeTotal--;
          presenceTypeTotalTantiemes -= itemUsedTantiemes;
        }
      }
      presenceTypeString = arrayToSort.sort().join(", ");

      return {
        presenceTypeTotal,
        presenceTypeTotalTantiemes,
        presenceTypeString,
      };
    },
  },
};
</script>
